import { createAPIService } from './api.service';

export const TENANT_ENDPOINT = '/user/api/v2/admin/tenants';

const service = createAPIService(TENANT_ENDPOINT);

// endpoints
service.getTenants = async params =>
  (await service.get('', { params: params })).data;

service.getTenant = async id => (await service.get(`/${id}`)).data;

service.getTenantByReferenceId = async referenceId =>
  await service.getTenants({
    tenantReferenceId: referenceId,
  });

service.createTenant = async tenant => (await service.post('', tenant)).data;

service.updateTenant = async (id, tenant) =>
  (await service.patch(`/${id}`, tenant)).data;

service.deleteTenant = async id => (await service.delete(`/${id}`)).data;

export default service;
